module.exports = __webpack_public_path__ + "img/RADS-alt.c0d34a7c.svg";